import React from 'react';
import { Switch, Redirect } from 'react-router-dom';

import { RouteWithLayout, PrivateRouteWithLayout } from './components';
import { Main as MainLayout, Minimal as MinimalLayout } from './layouts';

import {
  Dashboard as DashboardView,
  ProductList as ProductListView,
  UserList as UserListView,
  SlipData as SlipDataView,
  SlipReport as SlipReportView,
  MoneyTypeData as MoneyTypeDataView,
  UsersMoneyType as UsersMoneyTypeView,
  ReportData as ReportDataView,
  LoadDatas as LoadDatasView,
  /*Typography as TypographyView,
  Icons as IconsView,
  Account as AccountView,
  Settings as SettingsView,
  SignUp as SignUpView,*/
  SignIn as SignInView,
  NotFound as NotFoundView,
} from './views';

const Routes = () => {
  return (
    <Switch>
      <Redirect
        exact
        from="/"
        to="/slipreport"
      />
      <PrivateRouteWithLayout
        component={DashboardView}
        exact
        layout={MainLayout}
        path="/dashboard"
      />
      <PrivateRouteWithLayout
        component={SlipDataView}
        exact
        layout={MainLayout}
        path="/slipdata"
      /> 
      <PrivateRouteWithLayout
        component={SlipReportView}
        exact
        layout={MainLayout}
        path="/slipreportadmin"
      />
       <PrivateRouteWithLayout
        component={SlipDataView}
        exact
        layout={MainLayout}
        path="/slipdataadmin"
      /> 
      <PrivateRouteWithLayout
        component={SlipReportView}
        exact
        layout={MainLayout}
        path="/slipreport"
      />
      <PrivateRouteWithLayout
        component={MoneyTypeDataView}
        exact
        layout={MainLayout}
        path="/moneytypedata"
      />
      <PrivateRouteWithLayout
        component={UsersMoneyTypeView}
        exact
        layout={MainLayout}
        path="/usersmoneytypedata"
      />
       <PrivateRouteWithLayout
        component={ReportDataView}
        exact
        layout={MainLayout}
        path="/reportdata"
      />
      <PrivateRouteWithLayout
        component={LoadDatasView}
        exact
        layout={MainLayout}
        path="/loaddatas"
      />
     { /*<PrivateRouteWithLayout
        component={TypographyView}
        exact
        layout={MainLayout}
        path="/typography"
      />
      <PrivateRouteWithLayout
        component={IconsView}
        exact
        layout={MainLayout}
        path="/icons"
      />
      <PrivateRouteWithLayout
        component={AccountView}
        exact
        layout={MainLayout}
        path="/account"
      />
      <PrivateRouteWithLayout
        component={SettingsView}
        exact
        layout={MainLayout}
        path="/settings"
      />
      <RouteWithLayout
        component={SignUpView}
        exact
        layout={MinimalLayout}
        path="/sign-up"
     />*/}
      <RouteWithLayout
        component={SignInView}
        exact
        layout={MinimalLayout}
        path="/sign-in"
      />
      <RouteWithLayout
        component={NotFoundView}
        exact
        layout={MinimalLayout}
        path="/not-found"
      />
      <Redirect to="/not-found" />
    </Switch>
  );
};

export default Routes;
